<div class="container">
    <div class="xy50">
<app-heatmap class="d-flex align-items-center justify-content-center" *ngIf="idScenario != '0'" [idScenario]="idScenario"></app-heatmap>
</div>
</div>
<div class="container">
<div class="xy50">
<app-biplot *ngIf="idScenario != '0'" [idScenario]="idScenario"></app-biplot>
</div>
</div>